// src/components/OLTLogin/CircularProgress.js

import React, { useEffect, useState } from 'react';
import './CircularProgress.css';

const CircularProgress = ({ percentage, label }) => {
  const [displayPercentage, setDisplayPercentage] = useState(0);

  // রিয়েলটাইম smooth update
  useEffect(() => {
    let start = displayPercentage;
    const end = percentage;
    const duration = 800; // ms
    const stepTime = 20;
    const steps = duration / stepTime;
    const increment = (end - start) / steps;

    const interval = setInterval(() => {
      start += increment;
      if ((increment > 0 && start >= end) || (increment < 0 && start <= end)) {
        setDisplayPercentage(end);
        clearInterval(interval);
      } else {
        setDisplayPercentage(start);
      }
    }, stepTime);

    return () => clearInterval(interval);
  }, [percentage]);

  const rotation = (displayPercentage / 100) * 360;

  // CPU/RAM লোড অনুযায়ী রঙ পরিবর্তন
  const getColor = (value) => {
    if (value <= 50) return '#4caf50';      // Green
    if (value <= 80) return '#ffeb3b';      // Yellow
    return '#f44336';                        // Red
  };

  const color = getColor(displayPercentage);

  return (
    <div className="circular-container">
      <div className="circular">
        <div
          className="circle"
          style={{
            background: `conic-gradient(${color} ${rotation}deg, #e0e0e0 ${rotation}deg)`
          }}
        ></div>
        <div className="circle-center">
          <span className="circle-label">{label}</span>
          <span className="circle-percentage">{Math.round(displayPercentage)}%</span>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;

